// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"28d37c22","238":"edad3a88","239":"6e7c0e62","455":"46d61245","557":"dfafdfdc","762":"d3c11dcf"}[chunkId] + ".chunk.js";
};